/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.47567.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class PhoneControllerApi extends runtime.BaseAPI {
    /**
     */
    async createEmergencyAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.createEmergencyAddressOptions === null || requestParameters.createEmergencyAddressOptions === undefined) {
            throw new runtime.RequiredError('createEmergencyAddressOptions', 'Required parameter requestParameters.createEmergencyAddressOptions was null or undefined when calling createEmergencyAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/emergency-addresses`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createEmergencyAddressOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createEmergencyAddress(requestParameters, initOverrides) {
        const response = await this.createEmergencyAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteEmergencyAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.addressId === null || requestParameters.addressId === undefined) {
            throw new runtime.RequiredError('addressId', 'Required parameter requestParameters.addressId was null or undefined when calling deleteEmergencyAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/emergency-addresses/{addressId}`.replace(`{${"addressId"}}`, encodeURIComponent(String(requestParameters.addressId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteEmergencyAddress(requestParameters, initOverrides) {
        const response = await this.deleteEmergencyAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deletePhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters.phoneNumberId === null || requestParameters.phoneNumberId === undefined) {
            throw new runtime.RequiredError('phoneNumberId', 'Required parameter requestParameters.phoneNumberId was null or undefined when calling deletePhoneNumber.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/numbers/{phoneNumberId}`.replace(`{${"phoneNumberId"}}`, encodeURIComponent(String(requestParameters.phoneNumberId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deletePhoneNumber(requestParameters, initOverrides) {
        await this.deletePhoneNumberRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getEmergencyAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.addressId === null || requestParameters.addressId === undefined) {
            throw new runtime.RequiredError('addressId', 'Required parameter requestParameters.addressId was null or undefined when calling getEmergencyAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/emergency-addresses/{addressId}`.replace(`{${"addressId"}}`, encodeURIComponent(String(requestParameters.addressId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEmergencyAddress(requestParameters, initOverrides) {
        const response = await this.getEmergencyAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getEmergencyAddressesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/emergency-addresses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEmergencyAddresses(initOverrides) {
        const response = await this.getEmergencyAddressesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getPhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters.phoneNumberId === null || requestParameters.phoneNumberId === undefined) {
            throw new runtime.RequiredError('phoneNumberId', 'Required parameter requestParameters.phoneNumberId was null or undefined when calling getPhoneNumber.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/numbers/{phoneNumberId}`.replace(`{${"phoneNumberId"}}`, encodeURIComponent(String(requestParameters.phoneNumberId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPhoneNumber(requestParameters, initOverrides) {
        const response = await this.getPhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getPhoneNumbersRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.phoneCountry !== undefined) {
            queryParameters['phoneCountry'] = requestParameters.phoneCountry;
        }
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }
        if (requestParameters.include) {
            queryParameters['include'] = requestParameters.include;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/numbers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPhoneNumbers(requestParameters = {}, initOverrides) {
        const response = await this.getPhoneNumbersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getPhonePlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPhonePlans(initOverrides) {
        const response = await this.getPhonePlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getPhonePlansAvailabilityRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/plans/availability`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPhonePlansAvailability(initOverrides) {
        const response = await this.getPhonePlansAvailabilityRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async testPhoneNumberSendSmsRaw(requestParameters, initOverrides) {
        if (requestParameters.phoneNumberId === null || requestParameters.phoneNumberId === undefined) {
            throw new runtime.RequiredError('phoneNumberId', 'Required parameter requestParameters.phoneNumberId was null or undefined when calling testPhoneNumberSendSms.');
        }
        if (requestParameters.testPhoneNumberOptions === null || requestParameters.testPhoneNumberOptions === undefined) {
            throw new runtime.RequiredError('testPhoneNumberOptions', 'Required parameter requestParameters.testPhoneNumberOptions was null or undefined when calling testPhoneNumberSendSms.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xTestId !== undefined && requestParameters.xTestId !== null) {
            headerParameters['x-test-id'] = String(requestParameters.xTestId);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/phone/numbers/{phoneNumberId}/test`.replace(`{${"phoneNumberId"}}`, encodeURIComponent(String(requestParameters.phoneNumberId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.testPhoneNumberOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async testPhoneNumberSendSms(requestParameters, initOverrides) {
        await this.testPhoneNumberSendSmsRaw(requestParameters, initOverrides);
    }
}
/**
 * @export
 */
export const GetPhoneNumbersPhoneCountryEnum = {
    US: 'US',
    GB: 'GB',
    AU: 'AU'
};
/**
 * @export
 */
export const GetPhoneNumbersSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
